<template>
    <div class="report-occypancyrate">
        <div class="totle-content">
            <div class="select-search">
                <div class="select-group">
                    <!--<el-select v-model="value8" filterable placeholder="租客姓名">-->
                        <!--&lt;!&ndash;<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>&ndash;&gt;-->
                    <!--</el-select>-->
                    <!--<el-select v-model="value8" filterable placeholder="支付方式">-->
                        <!--&lt;!&ndash;<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>&ndash;&gt;-->
                    <!--</el-select>-->
                    <!--<el-date-picker v-model="date_value" type="daterange" align="right" unlink-panels range-separator="至"-->
                                    <!--start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2">-->
                    <!--</el-date-picker>-->
                </div>
                <div class="button-group">
                    <el-date-picker v-model="date_value" type="daterange" align="right" unlink-panels range-separator="至"
                                    start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2" value-format="yyyy-MM-dd" @change="occupancyrate">
                    </el-date-picker>
                    <!--<el-button type="primary" icon="el-icon-search" @click="occupancyrate">搜索</el-button>-->
                    <el-button type="success" icon="el-icon-tickets" @click="downloadMater">导出</el-button>
                </div>
            </div>

            <div class="table-content">
                <el-table class="table-head" :data="occupancyData" border>
                    <el-table-column align="center" type="index" width="50"></el-table-column>
                    <el-table-column align="center" prop="time" label="时间" sortable></el-table-column>
                    <el-table-column align="center" prop="numall" label="所有房间数"></el-table-column>
                    <el-table-column align="center" prop="numstay" label="入住房间数"></el-table-column>
                    <el-table-column align="center" prop="stayrate" label="入住率"></el-table-column>
                    <el-table-column align="center" prop="offrate" label="空置率"></el-table-column>
                </el-table>
            </div>
            <div class="pagination-part">
                <!--<el-pagination-->
                        <!--@size-change="handleSizeChange"-->
                        <!--@current-change="handleCurrentChange"-->
                        <!--:current-page="currentPage4"-->
                        <!--:page-sizes="[10, 20, 50, 100]"-->
                        <!--:page-size="20"-->
                        <!--layout="total, sizes, prev, pager, next, jumper"-->
                        <!--:total="total">-->
                <!--</el-pagination>-->
            </div>
        </div>
    </div>
</template>

<script>
    import store from "../store";
    var FileSaver = require('file-saver');

    export default {
        name: "ReportOccupancyrate",
        data() {
            return {
                pickerOptions2: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                value7: 0,
                value8: 0,
                total:0,
                occupancyData: [],

                date_value: [],
            };
        },
        mounted: function () {
            //初始获取最近一个月数据
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            end=store.getters.getNowFormatDate(end);
            start=store.getters.getNowFormatDate(start);
            this.date_value=[start,end];
            this.occupancyrate();
        },
        methods: {
            occupancyrate() {
                var begin_date = this.date_value[0];
                var end_date = this.date_value[1];
                this.$http.get(`${store.state.url}report/occupancyrate/`+begin_date+`/`+end_date+`?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            let Data = [];
                            let data = res.Data;
                            if(res.Data!=null) {
                                for (let i in res.Data) {
                                    Data[i] = {
                                        time: data[i]._id,
                                        numall: data[i].numall,
                                        numstay: data[i].numstay,
                                        stayrate: ((data[i].numstay / data[i].numall) * 100).toFixed(2) + "%",
                                        offrate: ((1 - (data[i].numstay / data[i].numall)) * 100).toFixed(2) + "%",
                                    };
                                }
                            }
                            this.occupancyData = Data;
                            //this.total=Data.length;
                        } else {
                            this.occupancyData =[];
                            this.$message(res.Message);
                        }
                    })
            },

            //导出excel
            downloadMater (){
                const defaultCellStyle =  { font: { name: "Verdana", sz: 11, color: "FF00FF88"}, fill: {fgColor: {rgb: "FFFFAA00"}}};
                const wopts = { bookType:'xlsx', bookSST:false, type:'binary', defaultCellStyle: defaultCellStyle, showGridLines: false};
                const wb = { SheetNames: ['Sheet1'], Sheets: {}, Props: {} };

                let Data=[];
                for(let i in this.occupancyData){
                    Data[i] = {
                        时间: this.occupancyData[i].time,
                        所有房间数: this.occupancyData[i].numall,
                        入住房间数: this.occupancyData[i].numstay,
                        入住率: this.occupancyData[i].stayrate,
                        空置率: this.occupancyData[i].offrate,
                    };
                }
                let data = Data;
                wb.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(data);

                //创建二进制对象写入转换好的字节流
                let tmpDown =  new Blob([this.s2ab(XLSX.write(wb, wopts))], { type: "application/octet-stream" })
                FileSaver.saveAs(tmpDown, "入住率报表.xls");
            },
            //字符串转字符流
            s2ab (s) {
                if (typeof ArrayBuffer !== 'undefined') {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                } else {
                    var buf = new Array(s.length);
                    for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }
            },
        }

    }
</script>

<style scoped>


</style>
